import React, { useEffect } from 'react';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getSocket } from '../utils/socket';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import AdminQuestions from './AdminQuestions';
import AdminMusics from './AdminMusics';
import AdminScores from './AdminScores';
import AdminGroups from './AdminGroups';
import AdminSeries from './AdminSeries';

function AdminLayout() {
  const { isAdmin, token, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    const socket = getSocket();
    const doAuth = () => socket.emit('admin:auth', { token }, () => {});
    if (!socket.connected) {
      socket.once('connect', doAuth);
      socket.connect();
    } else {
      doAuth();
    }
  }, [token]);

  if (!isAdmin) return <Navigate to="/admin/login" replace />;

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const links = [
    { to: '/admin', label: '🎮 Dashboard', end: true },
    { to: '/admin/questions', label: '❓ Questions' },
    { to: '/admin/series', label: '📚 Séries' },
    { to: '/admin/musics', label: '🎵 Musiques' },
    { to: '/admin/groups', label: '👥 Équipes' },
    { to: '/admin/scores', label: '🏆 Scores' },
  ];

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="sidebar-logo">🎵 BlindTest<br /><small>Admin</small></div>
        <nav>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <button className="sidebar-logout" onClick={handleLogout}>⏻ Déconnexion</button>
      </aside>
      <main className="admin-main">
        <Routes>
          <Route index element={<AdminDashboard />} />
          <Route path="questions" element={<AdminQuestions />} />
          <Route path="series" element={<AdminSeries />} />
          <Route path="musics" element={<AdminMusics />} />
          <Route path="groups" element={<AdminGroups />} />
          <Route path="scores" element={<AdminScores />} />
        </Routes>
      </main>
    </div>
  );
}

export default function AdminApp() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route path="*" element={<AdminLayout />} />
    </Routes>
  );
}
